<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getProductionQualityInspectionVisuals"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-inspection-number" label-cols-sm="4" label-cols-lg="3" label="Inspection Number" label-for="filter-inspection-number" size="sm" :model.sync="filter.inspectionNumber" />
						<app-input-datepicker-range id="fieldset-production-date" label-cols-sm="4" label-cols-lg="3" label="Production Date" size="sm" :modelFrom.sync="filter.productionDateFrom" :modelTo.sync="filter.productionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm" :model.sync="filter.partId" @input="getParts" @focus="getParts" />
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.customerPartId" @input="getCustomers" @focus="getCustomers" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getProductionQualityInspectionVisuals"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Production Quality Inspection Visual</span>
				</b-col>
				<!-- <b-col>
					<span class="float-right">
						<b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="/files/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col> -->
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<!-- <b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay> -->

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-productionqualityinspectionvisual" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="productionQualityInspectionVisuals" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="productionQualityInspectionVisuals.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
					<b-th stacked-heading="Inspection Number" class="table-filter">
						<b-form-input id="input-inspection-number-table" @input="getProductionQualityInspectionVisualsWithoutLoading" v-model="filter.inspectionNumber" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="ProductionDate" class="table-filter">
						<b-form-datepicker boundary="viewport" placeholder="" id="input-production-date-from-table" reset-button @input="getProductionQualityInspectionVisualsWithoutLoading" v-model="filter.productionDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						<b-form-datepicker boundary="viewport" placeholder="" id="input-production-date-to-table" reset-button @input="getProductionQualityInspectionVisualsWithoutLoading" v-model="filter.productionDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
						<!-- <app-input-datepicker-range id="fieldset-production-date" label-cols-sm="4" label-cols-lg="3" label="Production Date" size="sm" :modelFrom.sync="filter.productionDateFrom" :modelTo.sync="filter.productionDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  @change="getProductionQualityInspectionVisualsWithoutLoading" reset-button /> -->
					</b-th>
					<b-th stacked-heading="Part" class="table-filter">
						<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId" :reduce="item => item.id" v-model="filter.partId" :filterable="true" @input="getProductionQualityInspectionVisualsWithoutLoading" @search="getParts"></v-select>
					</b-th>
					<b-th stacked-heading="Customer" class="table-filter">
						<v-select append-to-body label="code" :options="customers" :value="filter.customerPartId" :reduce="item => item.id" v-model="filter.customerPartId" :filterable="true" @input="getProductionQualityInspectionVisualsWithoutLoading" @search="getCustomers"></v-select>
					</b-th>
					<b-th stacked-heading="Qty Ng" class="table-filter">
					</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(inspectionnumber)="row">
						<a @click="() => ( $router.push({ name: 'productionqualityinspectionvisualdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.inspectionNumber != null && row.item.inspectionNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.inspectionNumber.slice(0, 30) + (row.item.inspectionNumber.length > 30 ? "..." : "" ) : row.item.inspectionNumber : "" }}
						</a>
					</template>
					<template v-slot:cell(productionDate)="row">
						{{ row.item.productionDate | moment("DD-MMM-YYYY") }}
					</template>
					<template v-slot:cell(part)="row">
						{{ row.item.part != null ? row.item.part.partNumber : "" }}
					</template>
					<template v-slot:cell(customer)="row">
						{{ row.item.part != null && row.item.part.customer != null ? row.item.part.customer.code : "" }}
					</template>
					<template v-slot:cell(qtyNg)="row">
						{{ SumQtyNg(row.item) }}
					</template>

					<template v-slot:cell(front-action)="row">
						<!-- <div class="d-flex justify-content-center ml-2">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div> -->
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<a @click="() => ( $router.push({ name: 'productionqualityinspectionvisualdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.inspectionNumber != null && row.item.inspectionNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.inspectionNumber.slice(0, 30) + (row.item.inspectionNumber.length > 30 ? "..." : "" ) : row.item.inspectionNumber : "" }}
							</a>
							<app-input-datepicker id="fieldset-production-date" label-cols-lg="12"  label="Production Date" size="sm" :model.sync="row.item.productionDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partId" label="Part" :selected="row.item.part != null ? row.item.part.partNumber : ''" :isEditable="false" :isUpdatable="true" />
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(productionQualityInspectionVisualsPaging != null ? productionQualityInspectionVisualsPaging.dataCount : 0)"
									:per-page="(productionQualityInspectionVisualsPaging != null ? productionQualityInspectionVisualsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-productionqualityinspectionvisual.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-productionqualityinspectionvisual.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-productionqualityinspectionvisual.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ProductionQualityInspectionVisual from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisual';
import ProductionQualityInspectionVisualList from '@/models/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualList';
import ProductionQualityInspectionVisualFilter from '@/filters/ProductionQualityInspectionVisual/ProductionQualityInspectionVisualFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderExecutionDetailFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionDetailFilter';
import WorkOrderExecutionDetail from '@/models/WorkOrderExecution/WorkOrderExecutionDetail';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderExecutionNgFilter from '@/filters/WorkOrderExecutionNg/WorkOrderExecutionNgFilter';
import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		ProductionQualityInspectionVisual, 
		ProductionQualityInspectionVisualList, 
		ProductionQualityInspectionVisualFilter, 
		WorkOrderProcess, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputTextbox,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"inspectionNumber": {}, "class" : "th-inspection-number first-child", "label" : "Inspection Number", key: 'inspectionNumber', sortable: true}, 
				//{"workOrderProcessDetail": {}, "class" : "th-work-order-process-detail", "label" : "Work Order Process Detail", key: 'workOrderProcessDetail', sortable: true}, 
				//{"workOrderExecutionDetail": {}, "class" : "th-work-order-execution-detail last-child", "label" : "Work Order Execution Detail", key: 'workOrderExecutionDetail', sortable: true}, 
				{"productionDate": {}, "class" : "th-production-date d-stack-none", "label" : "Production Date", key: 'productionDate', sortable: true}, 
				{"part": {}, "class" : "th-part d-stack-none", "label" : "Part Number", key: 'part', sortable: true}, 
				{"customer": {}, "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: true}, 
				//{"ngCategoryName": {}, "class" : "th-ngCategoryName d-stack-none", "label" : "NG Category name", key: 'ngCategoryName', sortable: true}, 
				{"qtyNg": {}, "class" : "th-qtyNg d-stack-none", "label" : "Qty Ng", key: 'qtyNg', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			productionQualityInspectionVisuals: [],
			productionQualityInspectionVisualsPaging: {},
			workOrderProcessDetails : [],
			workOrderExecutionDetails : [],
			parts : [],
			productionQualityInspectionVisualDetails : [],
			customers: [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	
	methods : {
		SumQtyNg(item) {
			let totalQty = 0;
			item.productionQualityInspectionVisualDetail.forEach(p=> {
				totalQty += p.ngQty;
			});

			return totalQty;
		},
		getProductionQualityInspectionVisuals : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ProductionQualityInspectionVisual.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionVisuals = result.data
					this.productionQualityInspectionVisualsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getProductionQualityInspectionVisualsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			ProductionQualityInspectionVisual.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.productionQualityInspectionVisuals = result.data
					this.productionQualityInspectionVisualsPaging = result
				}
			})
			.catch(error => {});
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			// if (input != undefined) {
			// 	filter.part = input;
			// }
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderExecutionDetails : async function(input) {
			let filter = new WorkOrderExecutionDetailFilter();
			if (input != undefined) {
				filter.workOrderProcessDetail = input;
			}
			WorkOrderExecutionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutionDetails = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			if(input == '' && this.filter.partId != null) {
				filter.id = this.filter.partId;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if(input == '' && this.filter.customerPartId != null) {
				filter.id = this.filter.customerPartId;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ProductionQualityInspectionVisualFilter();
			this.getProductionQualityInspectionVisuals();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getProductionQualityInspectionVisuals();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ProductionQualityInspectionVisual.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ProductionQualityInspectionVisual.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			ProductionQualityInspectionVisual.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			ProductionQualityInspectionVisual.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'productionqualityinspectionvisualedit';
						if(this.isScannerMode) {
							createRoute = 'productionqualityinspectionvisualscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			ProductionQualityInspectionVisual.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'productionqualityinspectionvisualedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			ProductionQualityInspectionVisual.deleteData(this, id).then(result => {
				if (result)
				{
					this.getProductionQualityInspectionVisuals();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ProductionQualityInspectionVisual.deleteMultipleData(this).then(result => {
					this.getProductionQualityInspectionVisuals();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableProductionQualityInspectionVisualParent = document.getElementById('table-list-productionqualityinspectionvisual').parentNode;
			tableProductionQualityInspectionVisualParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableProductionQualityInspectionVisualParent.scrollWidth - tableProductionQualityInspectionVisualParent.offsetWidth) == Math.ceil(tableProductionQualityInspectionVisualParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableProductionQualityInspectionVisualParent = document.getElementById('table-list-productionqualityinspectionvisual').parentNode;
			tableProductionQualityInspectionVisualParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableProductionQualityInspectionVisualParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ProductionQualityInspectionVisualFilter();
		this.getWorkOrderProcessDetails()
		this.getWorkOrderExecutionDetails()
		this.getParts()
		this.getCustomers()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Production Quality Inspection Visual"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getProductionQualityInspectionVisuals();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getProductionQualityInspectionVisuals();
			}
		},
		sortDesc: {
			handler: function() {
				this.getProductionQualityInspectionVisuals();
			}
		},
		currentPage: {
			handler: function() {
				this.getProductionQualityInspectionVisuals();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getProductionQualityInspectionVisuals();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ProductionQualityInspectionVisual.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "productionqualityinspectionvisualindex") {
					this.getProductionQualityInspectionVisualsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "production_quality_inspection_visual").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
